<style type="text/css" scoped>
/* Chat drawer needs higher z-index than theme toggle button (z-index: 100) */
.card-details-drawer {
  z-index: 9999 !important;
}

/* Also hide theme toggle when chat drawer is open - global style */
.card-details-drawer~.theme-toggle-wrapper,
.v-navigation-drawer--open~.theme-toggle-wrapper {
  display: none !important;
}

.app_bar_shadow {
  box-shadow: 0px 4.5px 11.24px 0px #091E421A !important;
  height: auto !important;
  /* z-index: 500 !important; */
}

/* Allow Quick Access dropdown to overflow the toolbar */
.app_bar_shadow .v-toolbar__content {
  overflow: visible !important;
}

/* Divider between favourite icons and Quick Access button */
.qa-bar-divider {
  width: 1px;
  height: 18px;
  background: #D1D5DB;
  margin: 0 8px;
  flex-shrink: 0;
}

/* Favourite shortcut avatar circles in top bar */
.qa-fav-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 2px;
  flex-shrink: 0;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.qa-fav-avatar:hover {
  transform: scale(1.15);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.qa-fav-avatar-text {
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.3px;
  line-height: 1;
  user-select: none;
}

.app_z_index {
  z-index: 500 !important;
}

.hamburger_stl {
  width: 60px;
  height: 64px;
  flex-shrink: 0;
  cursor: pointer;
}

.product-switcher-icon {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 8px;
  transition: all 0.2s ease;
}

/* Quick Add Minutes topbar button */
.nav-minutes-btn {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  vertical-align: middle;
  background: linear-gradient(135deg, #E8553A, #1e2b6e);
  box-shadow: 0 3px 10px rgba(30, 43, 110, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.nav-minutes-btn:hover {
  transform: scale(1.12);
  box-shadow: 0 5px 16px rgba(30, 43, 110, 0.45);
}
.nav-minutes-btn:active { transform: scale(0.94); }
.nav-minutes-btn svg { width: 18px; height: 18px; }

/* STARR Implementation Programme button */
.nav-impl-btn {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  vertical-align: middle;
  background: linear-gradient(135deg, #D64B7A, #3B4CC0);
  box-shadow: 0 3px 10px rgba(59, 76, 192, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.nav-impl-btn:hover {
  transform: scale(1.12);
  box-shadow: 0 5px 16px rgba(59, 76, 192, 0.45);
}
.nav-impl-btn:active { transform: scale(0.94); }
.nav-impl-btn svg { width: 18px; height: 18px; }

/* Animated chat button */
.nav-chat-btn {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  vertical-align: middle;
  background: linear-gradient(135deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%);
  box-shadow: 0 3px 10px rgba(156, 39, 176, 0.35);
  animation: navChatGlow 2.6s ease-in-out infinite;
  transition: transform 0.2s ease;
}
.nav-chat-btn:hover { transform: scale(1.12) rotate(-5deg); }
.nav-chat-btn:active { transform: scale(0.94); }
.nav-chat-btn svg { width: 19px; height: 19px; }
.nav-chat-btn .nav-chat-dot {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 9px;
  height: 9px;
  background: #22c55e;
  border: 2px solid #fff;
  border-radius: 50%;
  animation: navChatPing 1.8s ease-out infinite;
}
.nav-chat-btn .nav-chat-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 17px;
  text-align: center;
  border-radius: 9px;
  border: 2px solid #fff;
  box-sizing: content-box;
}
.nav-chat-btn .nc-d1 { animation: navChatDot 1.2s ease-in-out infinite; }
.nav-chat-btn .nc-d2 { animation: navChatDot 1.2s ease-in-out 0.2s infinite; }
.nav-chat-btn .nc-d3 { animation: navChatDot 1.2s ease-in-out 0.4s infinite; }
@keyframes navChatGlow {
  0%, 100% { box-shadow: 0 3px 10px rgba(156, 39, 176, 0.35); }
  50% { box-shadow: 0 5px 18px rgba(233, 30, 99, 0.55); }
}
@keyframes navChatPing {
  0% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55); }
  70% { box-shadow: 0 0 0 7px rgba(34, 197, 94, 0); }
  100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
}
@keyframes navChatDot {
  0%, 100% { opacity: 0.35; }
  50% { opacity: 1; }
}

.product-switcher-icon:hover {
  background: rgba(67, 24, 255, 0.08);
  transform: scale(1.05);
}

.familybook_gradient_bg {
  background: linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%);
}

.starr_gradient_bg {
  background: linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%);
}

.board_gradient_bg {
  background: linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%);
}

.app_bar_shadow>>>.v-toolbar__content {
  padding: 0px;
  height: auto !important;
}

/* Navbar action buttons (Setup Guide) */
.nav-action-btn {
  border-radius: 6px !important;
  font-weight: 500 !important;
  letter-spacing: 0.3px !important;
  height: 26px !important;
  padding: 0 10px !important;
  font-size: 11px !important;
  background-color: transparent !important;
  white-space: nowrap !important;
}

.nav-action-btn::before {
  opacity: 0 !important;
}

/* Setup Guide button + popover */
.setup-btn-ring {
  flex-shrink: 0;
}

.drona-btn-icon {
  border-radius: 50%;
  flex-shrink: 0;
  filter: brightness(0) invert(1);
}

/* ================================================================
   Responsive top nav — mobile / tablet
   On small screens the gradient action buttons (CAC, My Work,
   Setup, Drona AI, Solutions, Role Profile) are hidden to keep the
   bar clean and aligned — they remain reachable via the sidebar
   menu. The essential icons stay in a single tidy row.
   ================================================================ */
@media (max-width: 960px) {
  .app_bar_shadow >>> .v-toolbar__content {
    height: auto !important;
    padding: 0 !important;
    align-items: center;
    flex-wrap: nowrap;
  }
  /* Hide the gradient action buttons on mobile */
  .nav-action-btn {
    display: none !important;
  }
  /* Hide the chat and Quick Add Minutes (meeting) buttons on mobile */
  .nav-chat-btn,
  .nav-minutes-btn {
    display: none !important;
  }
  /* Hide the entity name + divider to reclaim width */
  .company_txt,
  .logo_cmp_btw_border {
    display: none !important;
  }
}

@media (max-width: 600px) {
  .hamburger_stl {
    width: 48px;
    height: 56px;
  }
  /* Shrink the round icon buttons a touch */
  .nav-minutes-btn,
  .nav-chat-btn {
    width: 30px;
    height: 30px;
  }
  .nav-chat-btn svg { width: 16px; height: 16px; }
  .nav-minutes-btn svg { width: 15px; height: 15px; }
}

.company_txt {
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #3F4254;
}

.logo_cmp_btw_border {
  width: 21px;
  rotate: 90deg;
  top: 21.36px;
  left: 204.65px;
  border-width: 1.12px;
  border: 1.12px solid #E4E6EF
}

.menu_search {
  width: 600px;
}

.menu_search>>>.v-text-field--rounded>.v-input__control>.v-input__slot {
  padding: 0 10px !important;
}

.menu_search>>>.theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
  background: #F5F8FA !important;
}

.prof_img {
  width: 40px;
  height: 40px;
  border-radius: 6.75px;
}

.prof_name {
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #181C32;

}

.prof_dep_name {
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #181C32;
}

.sub_list_txt {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #3F4254;
}

.host-selected .v-list-item__title {
  font-weight: 600;
}

/* Starr host selected */
.host-selected-starr {
  background: linear-gradient(90deg, rgba(233, 30, 99, 0.12) 0%, rgba(156, 39, 176, 0.12) 50%, rgba(63, 81, 181, 0.12) 100%) !important;
}

/* Board host selected */
.host-selected-board {
  background: linear-gradient(90deg, rgba(255, 152, 0, 0.12) 0%, rgba(255, 87, 34, 0.12) 50%, rgba(244, 67, 54, 0.12) 100%) !important;
}

/* Familybook host selected */
.host-selected-familybook {
  background: linear-gradient(90deg, rgba(57, 130, 219, 0.12) 0%, rgba(87, 130, 199, 0.12) 50%, rgba(137, 83, 237, 0.12) 100%) !important;
}

/* Starr host hover */
.host-item-starr:hover {
  background: linear-gradient(90deg, rgba(233, 30, 99, 0.08) 0%, rgba(156, 39, 176, 0.08) 50%, rgba(63, 81, 181, 0.08) 100%) !important;
}

/* Board host hover */
.host-item-board:hover {
  background: linear-gradient(90deg, rgba(255, 152, 0, 0.08) 0%, rgba(255, 87, 34, 0.08) 50%, rgba(244, 67, 54, 0.08) 100%) !important;
}

/* Familybook host hover */
.host-item-familybook:hover {
  background: linear-gradient(90deg, rgba(57, 130, 219, 0.08) 0%, rgba(87, 130, 199, 0.08) 50%, rgba(137, 83, 237, 0.08) 100%) !important;
}

/* Company Styles */
.company-selected {
  background: rgba(76, 175, 80, 0.08) !important;
}

.company-selected .v-list-item__title {
  font-weight: 600;
  color: #4CAF50;
}
</style>

<template>
  <div>
    <v-navigation-drawer v-if="domain !== 'partner' && has_token" v-model="chatDialog" fixed right temporary width="902"
      class="card-details-drawer">
      <v-card flat>
        <v-toolbar :style="{ color: '#fff' }" class="familybook_gradient_bg">
          <v-toolbar-title style="font-size: 1.10rem !important;">INTERNAL CHAT ROOM</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon style="color:white" class="close-btn-meeting" @click="chatDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <ChatModal style="max-height: auto" />
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
    <!-- Favourite Confirmation Dialog -->
    <v-dialog v-model="favouriteConfirmDialog" max-width="450" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="d-flex align-center py-4" :style="{
          background: pendingFavouriteHost === 'STARR' ? 'linear-gradient(90deg, rgba(233, 30, 99, 0.1) 0%, rgba(156, 39, 176, 0.1) 50%, rgba(63, 81, 181, 0.1) 100%)' : pendingFavouriteHost === 'BOARD' ? 'linear-gradient(90deg, rgba(255, 152, 0, 0.1) 0%, rgba(255, 87, 34, 0.1) 50%, rgba(244, 67, 54, 0.1) 100%)' : 'linear-gradient(90deg, rgba(57, 130, 219, 0.1) 0%, rgba(87, 130, 199, 0.1) 50%, rgba(137, 83, 237, 0.1) 100%)'
        }">
          <v-icon
            :color="pendingFavouriteHost === 'STARR' ? '#9C27B0' : pendingFavouriteHost === 'BOARD' ? '#FF5722' : '#5782C7'"
            size="28" class="mr-3">mdi-heart</v-icon>
          <span :style="{
            color: pendingFavouriteHost === 'STARR' ? '#9C27B0' : pendingFavouriteHost === 'BOARD' ? '#FF5722' : '#5782C7',
            fontWeight: '600',
            fontSize: '18px'
          }">Set as Favourite</span>
        </v-card-title>
        <v-card-text class="pt-4 pb-2">
          <div class="text-body-1" style="color: #3F4254; line-height: 1.6;">
            <p class="mb-3">
              Are you sure you want to set
              <strong :style="{
                color: pendingFavouriteHost === 'STARR' ? '#9C27B0' : pendingFavouriteHost === 'BOARD' ? '#FF5722' : '#5782C7'
              }">{{ pendingFavouriteHost }}</strong> as your favourite?
            </p>
            <v-alert dense text type="info" class="mb-0" style="font-size: 13px;">
              <strong>What this means:</strong> After you login, you will be automatically redirected to
              <strong :style="{
                color: pendingFavouriteHost === 'STARR' ? '#9C27B0' : pendingFavouriteHost === 'BOARD' ? '#FF5722' : '#5782C7'
              }">{{ pendingFavouriteHost }}</strong> page directly.
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="cancelFavouriteDialog">
            Cancel
          </v-btn>
          <v-btn :style="{
            background: pendingFavouriteHost === 'STARR'
              ? 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)'
              : pendingFavouriteHost === 'BOARD'
                ? 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)'
                : 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
            color: 'white'
          }" @click="confirmSetFavourite">
            <v-icon left small>mdi-heart</v-icon>
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-app-bar v-if="navDevice==='desktop'" app class="app_bar_shadow pa-0" :class="menu_dialog ? 'app_z_index' : ''" clipped-left color="#fff">
      <!-- <section :class="board_bg_cls" class="hamburger_stl d-flex align-center justify-center"> -->

      <section v-if="!hide_navigation" :class="board_bg_cls" class="hamburger_stl d-flex align-center justify-center" @click=open__dialog()>
        <img src="@/assets/Menu/hamburger_icon.svg" width="23" height="20">
      </section>

      <section class="pl-5 align-center d-flex">
        <!-- 
        <template v-if="is__adani_page">
          <img src="@/assets/adani.png" width="100px" height="40px" />
          <span class="logo_cmp_btw_border"></span>
        </template>

<template v-if="is__gmr_page">
          <img src="@/assets/GMR_Group_(logo).svg" alt="GMR Logo" width="100px" height="40px" />
          <span class="logo_cmp_btw_border"></span>
        </template>

<template v-if="is__vardhman_page">
          <img src="@/assets/vardhman_3.png" alt="Vardhman Logo" width="100px" height="40px" />
          <span class="logo_cmp_btw_border"></span>
        </template>

<template v-if="is__parle_page">
          <img src="@/assets/Parle_Products_Logo.svg" alt="Parle Products Logo" width="100px" height="40px" />
          <span class="logo_cmp_btw_border"></span>
        </template>
<template v-if="is__granules_page">
          <img src="@/assets/granules.svg" alt="Granules" width="120px" height="40px" />
          <span class="logo_cmp_btw_border"></span>
        </template>

<template v-if="is__emami_page">
          <img src="@/assets/Emami_Group.svg" alt="Emami Group" width="100px" height="40px" />
          <span class="logo_cmp_btw_border"></span>
        </template> -->
        <!-- <template v-if="is_family_book">
          <img src="@/assets/familybook_logo.svg" width="100px" height="40px" />
          <span class="logo_cmp_btw_border"></span>
        </template> -->

        <!-- Show company logos when NOT in family book mode -->
        <template>
          <div class="logo-container">
            <img v-if="logoUrl" :src="logoUrl" width="100px" height="40px" @error="handleLogoError" />
            <span v-if="logoUrl" class="logo_cmp_btw_border"></span>
          </div>
        </template>
        <template v-if="is_family_book">
          <img src="@/assets/familybook_logo.svg" width="120px" height="auto" />
          <!-- <span class="logo_cmp_btw_border"></span> -->
        </template>
        <img v-else :src="menuLogo_Src" height="40px" style="width:auto;object-fit:contain;display:block" />

      </section>

      <section class=" pl-15 align-center d-flex menu_search" v-if="show_hide_mob_btn == 1">
        <!-- <v-text-field
          placeholder="Search"
          filled
          rounded
          dense
          hide-details="auto"
        >
         <template v-slot:prepend-inner>
            <section class="justify-center align-center d-flex pl-2 pt-1 pr-2 ">
               <img 
                src="@/assets/Menu/search_.svg"
                width="12px"
                height="13px"
              />
            </section>
          </template>
        </v-text-field> -->
      </section>

      <v-spacer></v-spacer>
      <template v-if="show_hide_mob_btn == 1">
        <section class="company_txt align-center d-flex">
          <!-- <span>Align Associate</span> -->
          <!-- <span>{{ is__adani_page ? 'Adani Enterprises Ltd' : entity_name }}</span> -->
          <template>
            <span>
              <a v-if="is__adani_page" href="https://www.adanienterprises.com/" target="_blank"
                rel="noopener noreferrer" class="external-link">
                Adani Enterprises Ltd
              </a>

              <a v-else-if="is__gmr_page" href="https://www.gmrgroup.in/airports/" target="_blank"
                rel="noopener noreferrer" class="external-link">
                GMR Airports Limited
              </a>

              <a v-else-if="is__vardhman_page" href="https://www.vardhman.com/" target="_blank"
                rel="noopener noreferrer" class="external-link">
                Vardhman
              </a>

              <a v-else-if="is__parle_page" href="https://www.parleproducts.com/" target="_blank"
                rel="noopener noreferrer" class="external-link">
                Parle Products
              </a>

              <a v-else-if="is__granules_page" href="https://granulesindia.com/" target="_blank"
                rel="noopener noreferrer" class="external-link">
                Granules India
              </a>

              <a v-else-if="is__emami_page" href="https://www.emamiltd.in/" target="_blank" rel="noopener noreferrer"
                class="external-link">
                Emami Ltd
              </a>

              <span v-else>
                {{ entity_name }}
              </span>
            </span>
          </template>

        </section>
        <span class="logo_cmp_btw_border"></span>
      </template>

      <!-- Trial subscription indicator -->
      <v-chip
        v-if="isTrialSubscription && !is_board_page && !is_family_book"
        x-small dark class="mr-2 font-weight-bold"
        color="amber darken-3"
        style="letter-spacing:.6px; font-size:10px"
      >
        TRIAL
      </v-chip>

      <!-- ═══ Quick Access + Setup Guide ═══ -->
      <template v-if="!is_board_page && !is_family_book && !hide_navigation">
        <!-- Setup Guide button (only when setup is incomplete) -->
        <v-menu v-if="setupPct < 100" open-on-hover close-on-content-click offset-y bottom
          nudge-bottom="4" content-class="setup-popover-menu" z-index="10000">
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-small dark class="mr-2 text-capitalize nav-action-btn"
              style="background: linear-gradient(90deg, #6366F1 0%, #4F46E5 50%, #4338CA 100%);"
              v-bind="attrs" v-on="on"
              @click="closeMenuAndGo('/setup_guide')">
              <svg class="setup-btn-ring mr-1" viewBox="0 0 36 36" width="14" height="14">
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="rgba(255,255,255,0.25)" stroke-width="3.5" />
                <circle cx="18" cy="18" r="15.9" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round"
                  :stroke-dasharray="setupPct + ' 100'" style="transform: rotate(-90deg); transform-origin: center;" />
              </svg>
              {{ setupPct }}% Setup
            </v-btn>
          </template>
          <v-card class="setup-popover-card">
            <div class="setup-pop-header">
              <div>
                <div class="setup-pop-title">{{ setupPct >= 100 ? 'Setup complete' : 'Setup in progress' }}</div>
                <div class="setup-pop-sub">{{ setupDoneTasks }}/{{ setupTotalTasks }} tasks done</div>
              </div>
            </div>
            <div class="setup-pop-track">
              <div class="setup-pop-fill" :style="{ width: setupPct + '%' }"></div>
            </div>
            <button class="setup-pop-btn" @click="closeMenuAndGo('/setup_guide')">
              {{ setupPct >= 100 ? 'View Setup' : 'Continue Setup' }} &rarr;
            </button>
          </v-card>
        </v-menu>

        <!-- Favourite shortcut icons -->
        <v-tooltip v-for="fav in topBarFavourites" :key="'qf-' + fav.module_key" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              class="qa-fav-avatar"
              :style="{ background: getFavItemColor(fav.module_key, fav.module_category) }"
              v-bind="attrs"
              v-on="on"
              @click="closeMenuAndGo(fav.module_route)"
            >
              <v-icon v-if="hasMeaningfulIcon(fav.module_icon)" size="15" color="#fff">{{ fav.module_icon }}</v-icon>
              <span v-else class="qa-fav-avatar-text">{{ getFavInitials(fav.module_name) }}</span>
            </div>
          </template>
          <span>{{ fav.module_name }}</span>
        </v-tooltip>

        <!-- Divider between icons and Quick Access button -->
        <div v-if="topBarFavourites.length" class="qa-bar-divider"></div>

        <!-- Quick Access dropdown (manage favourites) -->
        <QuickAccessPanel />
      </template>

      <section class="justify-center align-center d-flex px-2" style="flex-shrink: 0;">
        <v-icon v-if="isfamily_book == false && is_boardpage" medium title="Click to view dashboard"
          @click="redirect_to_dashboard()">mdi-view-dashboard</v-icon>
        <v-icon v-if="isfamily_book == false && is_boardpage" medium class="ml-2 mr-2"
          title="click to view LeaderShip Structure"
          @click="redirect_to_leader_ship_stucture()">mdi-family-tree</v-icon>
        <v-icon v-if="isfamily_book == true" medium class="ml-2 mr-2" title="Click to Family Tree"
          @click="redirect_to_family_tree()">mdi-family-tree</v-icon>
        <v-icon v-if="isfamily_book == true" medium class="ml-2 mr-2" title="Click to Family office"
          @click="redirect_to_family_office()">mdi-account-group</v-icon>
        <v-icon v-if="isfamily_book == true" medium class="ml-2 mr-2" title="Click to Family Forum"
          @click="redirect_to_family_forum()">mdi-forum</v-icon>
        <img v-if="isfamily_book == true" medium class="ml-2 mr-2" title="Click to Open Chat" @click="open_chat()"
          src="@/assets/messages-2.svg" style="cursor:pointer" width="20" height="20" />
        <template v-if="(entity__Data.length > 1 ? true : false && domain != 'admin')">
          <v-icon width="26px" height="26px" class="mr-2" @click="Switch_Entities">mdi-swap-horizontal</v-icon>
        </template>

        <!-- NOTE (20260304150000): Switch Company — only shown for login_by_domain (starrboard.com) users -->
        <template v-if="has_multi_domain">
          <v-tooltip bottom z-index="10000">
            <template v-slot:activator="{ on, attrs }">
              <v-icon width="26px" height="26px" class="mr-2" v-bind="attrs" v-on="on"
                @click="open_switch_company">mdi-office-building-outline</v-icon>
            </template>
            <span>Switch Company</span>
          </v-tooltip>
        </template>

        <!-- Quick Add Minutes -->
        <v-tooltip v-if="!is_board_page && !is_family_book && !hide_navigation" bottom z-index="10000">
          <template v-slot:activator="{ on, attrs }">
            <div class="nav-minutes-btn mr-2" v-bind="attrs" v-on="on" @click="toggleQuickMinutes">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </div>
          </template>
          <span>Quick Add Minutes</span>
        </v-tooltip>

        <!-- STARR Implementation Programme -->
        <v-tooltip v-if="!is_family_book && !hide_navigation" bottom z-index="10000">
          <template v-slot:activator="{ on, attrs }">
            <div class="nav-impl-btn mr-2" v-bind="attrs" v-on="on" @click="$router.push('/starr_implementation_programme')">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 11l3 3L22 4"/>
                <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
              </svg>
            </div>
          </template>
          <span>STARR Implementation Programme</span>
        </v-tooltip>

        <!-- Chat (ChatHub) -->
        <v-tooltip v-if="!is_family_book && !hide_navigation" bottom z-index="10000">
          <template v-slot:activator="{ on, attrs }">
            <div class="nav-chat-btn mr-2" v-bind="attrs" v-on="on" @click="closeMenuAndGo('/chat_hub')">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 3C6.48 3 2 6.58 2 11c0 2.18 1.08 4.15 2.85 5.58L4 21l4.36-1.78c1.13.37 2.36.78 3.64.78 5.52 0 10-3.58 10-8s-4.48-8-10-8z" fill="#fff"/>
                <circle class="nc-d1" cx="8.5" cy="11" r="1.2" fill="#E91E63"/>
                <circle class="nc-d2" cx="12" cy="11" r="1.2" fill="#9C27B0"/>
                <circle class="nc-d3" cx="15.5" cy="11" r="1.2" fill="#3F51B5"/>
              </svg>
              <span v-if="chatUnread > 0" class="nav-chat-badge">{{ chatUnread > 99 ? '99+' : chatUnread }}</span>
              <span v-else class="nav-chat-dot"></span>
            </div>
          </template>
          <span>Chat</span>
        </v-tooltip>

        <!-- Product Switcher Icon -->
        <!-- <v-tooltip v-if="!is_family_book && !hide_navigation" bottom z-index="10000">
          <template v-slot:activator="{ on, attrs }">
            <div class="product-switcher-icon mr-2" v-bind="attrs" v-on="on" @click="productSwitcherDialog = true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="2" width="9" height="9" rx="2.5" fill="#7C3AED" stroke="#1e293b" stroke-width="1.5" />
                <rect x="13" y="2" width="9" height="9" rx="2.5" fill="#22C55E" stroke="#1e293b" stroke-width="1.5" />
                <rect x="2" y="13" width="9" height="9" rx="2.5" fill="#3B82F6" stroke="#1e293b" stroke-width="1.5" />
                <rect x="13" y="13" width="9" height="9" rx="2.5" fill="#F97316" stroke="#1e293b" stroke-width="1.5" />
              </svg>
            </div>
          </template>
          <span>Switch Product</span>
        </v-tooltip> -->

        <!-- Host Swap Icon for Single Entity -->
        <v-menu offset-y v-if="isSingleEntity && hasMultipleHosts">
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip bottom z-index="10000">
              <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                <v-icon width="26px" height="26px" class="mr-2" v-bind="{ ...attrs, ...tooltipAttrs }"
                  v-on="{ ...on, ...tooltipOn }" :color="themeColor">
                  mdi-star-settings-outline
                </v-icon>
              </template>
              <span>Switch Host</span>
            </v-tooltip>
          </template>
          <v-list dense>
            <!-- Company Selection (if available) -->
            <template v-if="has_company_data && company_dataset && company_dataset.length > 0">
              <v-subheader class="px-4" style="font-weight: 600; color: #3F4254;">Select Company</v-subheader>
              <v-list-item-group>
                <v-list-item v-for="company in company_dataset" :key="'company-' + company.id"
                  @click="selectCompany(company)" :class="{ 'company-selected': company_id === company.id }" :style="{
                    borderLeft: company_id === company.id ? '4px solid #4CAF50' : '4px solid transparent',
                    background: company_id === company.id ? 'rgba(76, 175, 80, 0.08)' : 'transparent'
                  }">
                  <v-list-item-icon>
                    <v-icon :color="company_id === company.id ? '#4CAF50' : '#7E8299'">
                      {{ company_id === company.id ? 'mdi-office-building' : 'mdi-office-building-outline' }}
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      :style="{ color: company_id === company.id ? '#4CAF50' : '#3F4254', fontWeight: company_id === company.id ? 600 : 400 }">
                      {{ company.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon v-if="company_id === company.id">
                    <v-icon color="#4CAF50">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                </v-list-item>
              </v-list-item-group>
              <v-divider class="my-2"></v-divider>
            </template>

            <!-- Host Selection -->
            <v-subheader class="px-4" style="font-weight: 600; color: #3F4254;">Select Host</v-subheader>
            <v-list-item-group v-model="selectedHostIndex">
              <v-list-item v-if="entity_starr_flag" @click="switchToHost('starr')"
                :class="{ 'host-selected': isCurrentHost('starr'), 'host-selected-starr': isCurrentHost('starr'), 'host-item-starr': true }"
                :style="{
                  borderLeft: '4px solid transparent',
                  borderImage: 'linear-gradient(180deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%) 1',
                  position: 'relative'
                }">
                <v-list-item-icon>
                  <v-icon :style="isCurrentHost('starr') ? {
                    background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  } : {}" :color="isCurrentHost('starr') ? '' : '#7E8299'">
                    {{ isCurrentHost('starr') ? 'mdi-star' : 'mdi-star-outline' }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title :style="isCurrentHost('starr') ? {
                    background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  } : {}">Starr</v-list-item-title>
                  <v-list-item-subtitle>Compliance</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="my-0 ml-0 mr-1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :style="user_favourite && user_favourite.toUpperCase() === 'STARR' ? {
                        background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                      } : {}" :color="user_favourite && user_favourite.toUpperCase() === 'STARR' ? '' : '#B5B5C3'"
                        size="18" @click.stop="setFavouriteHost('STARR')">
                        {{ user_favourite && user_favourite.toUpperCase() === 'STARR' ? 'mdi-heart' :
                          'mdi-heart-outline' }}
                      </v-icon>
                    </template>
                    <span>{{ user_favourite && user_favourite.toUpperCase() === 'STARR' ? 'Remove from favourite' : 'Set
                    as
                      favourite' }}</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-icon v-if="isCurrentHost('starr')">
                  <v-icon :style="{
                    background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }">mdi-check-circle</v-icon>
                </v-list-item-icon>
              </v-list-item>

              <v-list-item v-if="entity_board_flag" @click="switchToHost('board')"
                :class="{ 'host-selected': isCurrentHost('board'), 'host-selected-board': isCurrentHost('board'), 'host-item-board': true }"
                :style="{
                  borderLeft: '4px solid transparent',
                  borderImage: 'linear-gradient(180deg, #FF9800 0%, #FF5722 50%, #F44336 100%) 1',
                  position: 'relative'
                }">
                <v-list-item-icon>
                  <v-icon :style="isCurrentHost('board') ? {
                    background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  } : {}" :color="isCurrentHost('board') ? '' : '#7E8299'">
                    {{ isCurrentHost('board') ? 'mdi-star' : 'mdi-star-outline' }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title :style="isCurrentHost('board') ? {
                    background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  } : {}">Board</v-list-item-title>
                  <v-list-item-subtitle>Board Page</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="my-0 ml-0 mr-1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :style="user_favourite && user_favourite.toUpperCase() === 'BOARD' ? {
                        background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                      } : {}" :color="user_favourite && user_favourite.toUpperCase() === 'BOARD' ? '' : '#B5B5C3'"
                        size="18" @click.stop="setFavouriteHost('BOARD')">
                        {{ user_favourite && user_favourite.toUpperCase() === 'BOARD' ? 'mdi-heart' :
                          'mdi-heart-outline' }}
                      </v-icon>
                    </template>
                    <span>{{ user_favourite && user_favourite.toUpperCase() === 'BOARD' ? 'Remove from favourite' : 'Set
                    as
                      favourite' }}</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-icon v-if="isCurrentHost('board')">
                  <v-icon :style="{
                    background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }">mdi-check-circle</v-icon>
                </v-list-item-icon>
              </v-list-item>

              <v-list-item v-if="entity_family_book_flag" @click="switchToHost('familybook')"
                :class="{ 'host-selected': isCurrentHost('familybook'), 'host-selected-familybook': isCurrentHost('familybook'), 'host-item-familybook': true }"
                :style="{
                  borderLeft: '4px solid transparent',
                  borderImage: 'linear-gradient(180deg, #3982DB 0%, #5782C7 50%, #8953ED 100%) 1',
                  position: 'relative'
                }">
                <v-list-item-icon>
                  <v-icon :style="isCurrentHost('familybook') ? {
                    background: 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  } : {}" :color="isCurrentHost('familybook') ? '' : '#7E8299'">
                    {{ isCurrentHost('familybook') ? 'mdi-star' : 'mdi-star-outline' }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title :style="isCurrentHost('familybook') ? {
                    background: 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  } : {}">Familybook</v-list-item-title>
                  <v-list-item-subtitle>Family Tree</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="my-0 ml-0 mr-1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" :style="user_favourite && user_favourite.toUpperCase() === 'FAMILYBOOK' ? {
                        background: 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text'
                      } : {}" :color="user_favourite && user_favourite.toUpperCase() === 'FAMILYBOOK' ? '' : '#B5B5C3'"
                        size="18" @click.stop="setFavouriteHost('FAMILYBOOK')">
                        {{ user_favourite && user_favourite.toUpperCase() === 'FAMILYBOOK' ? 'mdi-heart' :
                          'mdi-heart-outline' }}
                      </v-icon>
                    </template>
                    <span>{{ user_favourite && user_favourite.toUpperCase() === 'FAMILYBOOK' ? 'Remove from favourite' :
                      'Set
                      as favourite' }}</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-icon v-if="isCurrentHost('familybook')">
                  <v-icon :style="{
                    background: 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }">mdi-check-circle</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-menu offset-y class="">
          <template v-slot:activator="{ on, attrs }">
            <section v-bind="attrs" v-on="on" class="justify-center align-center d-flex">
              <img :src="profileImage" @error="setFallbackImage" class="prof_img" alt="altText" />
              <div class="pl-2" v-if="show_hide_mob_btn == 1">
                <div class="prof_name" :title="username"> {{ user__name_concat }} <v-icon
                    color="#A4A4A4">mdi-chevron-down</v-icon></div>
                <div class="prof_dep_name pt-1" :title="username">{{ user__dep_concat }}</div>
              </div>
            </section>
          </template>
          <v-list class="sub_list_txt">
            <v-list-item @click="UpdateProfile">
              <v-list-item-title class="sub_list_txt x-18">
                <v-icon size="23">mdi-account-details </v-icon> My Profile
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="Switch_Entities" v-if="(entity__Data.length > 1 ? true : false && domain != 'admin')">
              <v-list-item-title class="sub_list_txt x-18">
                <v-icon size="23">mdi-swap-horizontal</v-icon> Entity : {{ entity_name }}
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="setupPct >= 100" @click="closeMenuAndGo('/setup_guide')">
              <v-list-item-title class="sub_list_txt x-18">
                <v-icon size="23">mdi-cog-outline</v-icon> Setup Guide
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="closeMenuAndGo('/help')">
              <v-list-item-title class="sub_list_txt x-18">
                <v-icon size="23">mdi-help-circle-outline</v-icon> Help
              </v-list-item-title>
            </v-list-item>

            <v-list-item @click="logout()">
              <v-list-item-title class="sub_list_txt x-19"><v-icon size="23">mdi-logout</v-icon>
                Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </section>
    </v-app-bar>

    <TopNavBarTablet v-else-if="navDevice==='tablet'" :vm="this" ref="tabletBar" />
    <TopNavBarMobile v-else :vm="this" ref="mobileBar" />

    <!-- Quick Add Minutes Drawer — moved out of the desktop-only <v-app-bar> so
         this.$refs.quickAddMinutes (toggleQuickMinutes()) keeps resolving no
         matter which device tier is currently mounted. Invisible until toggled,
         so its position in the DOM has no visual effect. -->
    <quick-add-minutes ref="quickAddMinutes" />

    <!-- Product Switcher Dialog -->
    <ProductSwitcherDialog v-model="productSwitcherDialog" />

    <!-- NOTE (20260304150000): Switch Company Dialog for login_by_domain flow -->
    <SwitchCompanyDialog :visible.sync="show_company_switch_dialog" :entities="company_switch_entities"
      :loading="company_switch_loading" @confirm="handle_company_switch_confirm" />

  </div>
</template>

<script>
import { api } from "@/services/api";
import moment from "moment";
import ProductSwitcherDialog from "./ProductSwitcherDialog.vue";
import ChatModal from '@/views/chatdetails/chatwindow';
import SwitchCompanyDialog from "@/components/SwitchCompanyDialog.vue";
import QuickAddMinutes from "@/components/QuickAddMinutes.vue";
import QuickAccessPanel from "@/components/Menu/QuickAccessPanel.vue";
var QA_CATEGORY_COLORS = require("@/components/Menu/QuickAccessItems").CATEGORY_COLORS;
var QA_ITEM_ICON_COLORS = require("@/components/Menu/QuickAccessItems").ITEM_ICON_COLORS;
import { processDomainEntitySwitch, invalidateTokenOnLogout } from "@/services/loginHelper.js";
import TopNavBarTablet from "./TopNavBar/TopNavBarTablet.vue";
import TopNavBarMobile from "./TopNavBar/TopNavBarMobile.vue";

export default {
  name: "TopNavBar",
  components: {
    ProductSwitcherDialog,
    ChatModal,
    SwitchCompanyDialog,
    'quick-add-minutes': QuickAddMinutes,
    QuickAccessPanel,
    TopNavBarTablet,
    TopNavBarMobile,
  },
  props: {
    is_board_page: {
      type: Boolean,
      default: false,
    },
    is__adani_page: {
      type: Boolean,
      default: false,
    },
    is__gmr_page: {
      type: Boolean,
      default: false,
    },

    is__vardhman_page: {
      type: Boolean,
      default: false,
    },


    is__parle_page: {
      type: Boolean,
      default: false,
    },

    is__granules_page: {
      type: Boolean,
      default: false,
    },

    is__emami_page: {
      type: Boolean,
      default: false,
    },

    menu_dialog: {
      type: Boolean,
      default: false,
    },
    entity__Data: {
      type: Array,
      default: [],
    },
    show_hide_mob_btn: {
      type: Number,
      default: 0,
    },
    hide_navigation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    navDevice() {
      // NOTE: deliberately not using $vuetify.breakpoint.mobile/lgAndUp —
      // those are gated by Vuetify's default mobileBreakpoint (1264), which
      // made 'tablet' unreachable at any width. Explicit width thresholds
      // (matching Vuetify's own sm/md/lg boundaries) give mobile/tablet/desktop
      // each a real range: <960 mobile, 960-1263 tablet, >=1264 desktop.
      const w = this.$vuetify.breakpoint.width
      if (w < 960) return 'mobile'
      if (w < 1264) return 'tablet'
      return 'desktop'
    },
    topBarFavourites() {
      return this.$store.getters["quickAccessFavourites/favouritesList"];
    },
    is_family_book() {
      return localStorage.getItem("is_family_book") === "true";
    },
    computedLogoUrl() {
      // If logoUrl is a relative filename from the API, build the full CDN path
      if (this.logoUrl && !this.logoUrl.startsWith("https")) {
        return `https://devcdn.tectalik.com/compliance/uploads/original_${this.logoUrl}`;
      }
      return this.logoUrl;
    },
    isDarkMode() {
      return this.$vuetify.theme.dark;
    },
    adani_bg_cls() {
      return this.is__adani_page ? 'bg_clr_adani' : 'bg_clr_orange'
    },
    gmr_bg_cls() {
      return this.is__gmr_page ? 'bg_clr_gmr' : 'bg_clr_orange'
    },
    vardhman_bg_cls() {
      return this.is__vardhman_page ? 'bg_clr_vardhman' : 'bg_clr_orange'
    },
    parle_bg_cls() {
      return this.is__parle_page ? 'bg_clr_parle' : 'bg_clr_orange'
    },
    granules_bg_cls() {
      return this.is__granules_page ? 'bg_clr_granules' : 'bg_clr_orange'
    },
    emami_bg_cls() {
      return this.is__emami_page ? 'bg_clr_emami' : 'bg_clr_orange'
    },


    board_bg_cls() {
      // Check if family book localStorage is set
      if (this.is_family_book) {
        return 'familybook_gradient_bg';
      }

      if (this.is_board_page == true) {
        if (this.is__adani_page == true) {
          return this.adani_bg_cls;
        } else if (this.is__gmr_page == true) {
          return this.gmr_bg_cls;
        }
        else if (this.is__vardhman_page == true) {
          return this.vardhman_bg_cls;
        }
        else if (this.is__parle_page == true) {
          return this.parle_bg_cls;
        } else if (this.is__granules_page == true) {
          return this.granules_bg_cls;
        } else if (this.is__emami_page == true) {
          return this.emami_bg_cls;
        }
        else {
          return 'board_gradient_bg';
        }
      } else {
        return 'starr_gradient_bg';
      }

    },

    menuLogo_Src() {
      if (this.is_family_book) {
        return require('@/assets/familybook_logo.svg');
      }
      return this.is_board_page ? require('@/assets/Menu/board_menu.png') : require('@/assets/starr.png')
    },
    user__name_concat() {
      return this.username ? (this.username.length >= 15 ? this.username.substring(0, 15) + "..." : this.username) : null;
    },
    user__dep_concat() {
      return this.user_dep ? (this.user_dep.length >= 15 ? this.user_dep.substring(0, 15) + "..." : this.user_dep) : null;
    },
    profileImage() {
      if (localStorage.getItem("LOGGED_EMP_PROFILE_IMG")) {
        return localStorage.getItem("LOGGED_EMP_PROFILE_IMG");
      }
      return require('@/assets/Menu/Empty_Profile_Pic.jpg');
    },
    isSingleEntity() {
      // Single entity when entity_dataset has only 1 entity
      return this.entity__Data && this.entity__Data.length == 1;
    },

    // NOTE (20260304150000): show switch company button when user logged in via login_by_domain
    has_multi_domain() {
      const stored = localStorage.getItem("ALL_ENTITIES");
      if (!stored) return false;
      try {
        const entities = JSON.parse(stored);
        const domains = [...new Set(entities.map(e => e.sub_domain))];
        return domains.length > 1 || entities.length > 1;
      } catch {
        return false;
      }
    },
    currentEntity() {
      // Get current entity from entity__Data based on localStorage ENTITY_ID
      const entityId = parseInt(localStorage.getItem("ENTITY_ID"));
      if (!entityId || !this.entity__Data || this.entity__Data.length === 0) return null;
      return this.entity__Data.find(e => e.id === entityId) || this.entity__Data[0];
    },
    entity_starr_flag() {
      // Use entity's starr_flag only
      return this.currentEntity?.starr_flag || false;
    },
    entity_board_flag() {
      // Use entity's board_flag only
      return this.currentEntity?.board_flag || false;
    },
    entity_family_book_flag() {
      // Use entity's family_book_flag only
      return this.currentEntity?.family_book_flag || false;
    },
    hasMultipleHosts() {
      // Check if entity has access to more than one host
      const hostCount = [this.entity_starr_flag, this.entity_board_flag, this.entity_family_book_flag].filter(Boolean).length;
      return hostCount > 1;
    },
    themeColor() {
      return this.is_board_page ? "#ffa500" : "#4318ff";
    },
  },
  data() {
    return {
      has_token: !!localStorage.getItem("TOKEN"),
      isTrialSubscription: localStorage.getItem("SUBSCRIPTION_STATUS") === "TRIAL",
      username: localStorage.getItem("USER_NAME"),
      user_dep: localStorage.getItem("USER_DESIGNATION"),
      entity_name: localStorage.getItem("entity_name"),
      domain: localStorage.getItem("domain"),
      logoUrl: null,
      logged_user_Email: localStorage.getItem("USER_EMAIL"),
      productSwitcherDialog: false,

      is_boardpage: localStorage.getItem("is_boardpage") === "true",
      secretary_flag: localStorage.getItem("SECRETARY_FLAG") === "true",
      chairman_flag: localStorage.getItem("CHAIRMAN_FLAG") === "true",
      ceo_flag: localStorage.getItem("CEO_FLAG") === "true",
      // is_family_book is a computed property (see computed:) — not duplicated in data
      // Host flags
      user_starr_flag: false,
      user_board_flag: false,
      user_family_book_flag: false,
      user_favourite: null,

      selectedHostIndex: null,
      currentHost: null,
      isfamily_book: false,
      // Favourite confirmation dialog
      favouriteConfirmDialog: false,
      pendingFavouriteHost: null,

      // Company data
      company_dataset: [],
      has_company_data: false,
      company_id: null,
      chatDialog: false,
      // NOTE (20260304150000): switch company dialog (login_by_domain flow)
      show_company_switch_dialog: false,
      company_switch_loading: false,
      company_switch_entities: [],

      // ── Setup guide progress (for nav icon) ──
      // Default 100 means "complete" = icon hidden.
      // loadSetupProgress() fetches the real value on mount and updates this.
      // When < 100, a progress ring icon appears in the navbar linking to /setup_guide.
      setupPct: 100,
      setupDoneTasks: 0,
      setupTotalTasks: 0,
      chatUnread: 0,
      chatUnreadTimer: null,
    }
  },
  mounted() {
    // Initialize theme from localStorage on component mount
    const savedTheme = localStorage.getItem('theme_mode');
    if (savedTheme) {
      this.$vuetify.theme.dark = savedTheme === 'dark';
    }
    // Fetch setup guide completion % on initial load
    this.loadSetupProgress();
    // Listen for live progress changes from setup_guide page
    this.$root.$on('setup-progress-changed', this.loadSetupProgress);
    // Chat unread badge — load once; refreshed on navigation (no periodic polling)
    this.loadChatUnread();
  },
  beforeDestroy() {
    this.$root.$off('setup-progress-changed', this.loadSetupProgress);
    if (this.chatUnreadTimer) clearInterval(this.chatUnreadTimer);
  },
  watch: {
    // Refresh setup progress when user leaves the setup_guide page.
    // This ensures the navbar icon updates if they completed tasks during their visit.
    '$route.path'(newPath, oldPath) {
      if (oldPath === '/setup_guide' && newPath !== '/setup_guide') {
        this.loadSetupProgress();
      }
      // refresh unread badge when leaving the chat page (unread gets cleared there)
      if (oldPath === '/chat_hub' && newPath !== '/chat_hub') {
        this.loadChatUnread();
      }
    },
    // Hide theme toggle button when chat dialog opens
    chatDialog(isOpen) {
      const toggleWrapper = document.querySelector('.theme-toggle-wrapper');
      if (toggleWrapper) {
        toggleWrapper.style.display = isOpen ? 'none' : 'block';
      }
    }
  },
  created() {
    // Skip all API calls if no token (e.g. public survey answer pages)
    const token = localStorage.getItem('TOKEN');
    if (!token) return;
    // Skip admin-specific API calls for partner domain
    const domain = localStorage.getItem('domain');
    if (domain !== 'partner') {
      this.getDomainLogo();
      this.fetchUserFlags();
      this.detectCurrentHost();
      // Fetch quick access favourites, then seed defaults for first-time users
      var self = this;
      this.$store.dispatch("quickAccessFavourites/fetchFavourites").then(function () {
        self.$store.dispatch("quickAccessFavourites/initializeDefaults");
      });
    }
  },
  methods: {
    // ── Setup Guide Progress ──────────────────────────────────────────────
    // Fetches the setup guide completion percentage for the current entity.
    // Used to show/hide the setup guide icon in the top navbar.
    //
    // How it works:
    //   1. Reads ENTITY_ID from localStorage (set during login)
    //   2. Fetches two APIs in parallel:
    //      - GET /setup_guide/tasks        → all setup phases with their tasks
    //      - GET /setup_guide/progress     → completed task records for this entity
    //   3. Calculates: setupPct = (doneTasks / totalTasks) * 100
    //   4. If setupPct < 100 → the setup guide icon is visible in the navbar
    //      If setupPct = 100 → icon is hidden (setup complete)
    //
    // Called on: mount + when navigating away from /setup_guide
    // Fails silently — if API is down, setupPct stays 100 (icon hidden).
    async loadSetupProgress() {
      const entityId = parseInt(localStorage.getItem("ENTITY_ID")) || 0;
      if (!entityId) return;

      try {
        const axios = (await import("axios")).default;

        // Single phase with 1 task: "Launch Setup Wizard"
        // Matches the frontend setup_guide.vue DEFAULT_PHASES
        var totalTasks = 1;

        var progressRes = await axios.get("setup_guide/progress", { params: { entity_id: entityId } });
        var autoMap = progressRes.data.auto_detected || {};

        // "Setup Wizard" is done when core steps have data
        var wizCoreKeys = ["Companies", "Departments", "Health Check"];
        var wizardDone = wizCoreKeys.every(function (k) { return autoMap[k]; });

        var doneTasks = wizardDone ? 1 : 0;

        this.setupDoneTasks = doneTasks;
        this.setupTotalTasks = totalTasks;
        this.setupPct = totalTasks ? Math.round((doneTasks / totalTasks) * 100) : 100;
      } catch (e) {
        // Silently fail — icon stays hidden (setupPct default = 100)
      }
    },
    // Total unread chat messages -> red badge on the chat icon. Fails silently.
    async loadChatUnread() {
      const entityId = parseInt(localStorage.getItem("ENTITY_ID")) || 0;
      const userId = parseInt(localStorage.getItem("USER_ID")) || 0;
      if (!entityId || !userId) return;
      try {
        const r = await api.get("/chat/unread_count", {
          params: { user_id: userId, entity_id: entityId },
          validateStatus: function() { return true; },
        });
        if (r.status === 200) {
          this.chatUnread = (r.data && r.data.count) || 0;
        }
      } catch (e) { /* silent */ }
    },
    getFavCategoryColor(category) {
      return QA_CATEGORY_COLORS[category] || "#64748B";
    },
    getFavItemColor(key, category) {
      return QA_ITEM_ICON_COLORS[key] || QA_CATEGORY_COLORS[category] || "#94A3B8";
    },
    hasMeaningfulIcon(icon) {
      return icon && icon !== "" && icon !== "mdi-circle-outline";
    },
    getFavInitials(name) {
      if (!name) return "?";
      var words = name.trim().split(/\s+/);
      if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
      }
      // Single word: take first 2 chars
      return name.substring(0, 2).toUpperCase();
    },
    closeMenuAndGo(route) {
      if (this.menu_dialog) this.$emit('to_open_MenuDialog');
      // Avoid "NavigationDuplicated" error when already on the target route
      if (this.$route.path === route) return;
      this.$router.push(route).catch((err) => {
        if (err && err.name !== 'NavigationDuplicated') throw err;
      });
    },
    toggleQuickMinutes() {
      if (this.$refs.quickAddMinutes) {
        this.$refs.quickAddMinutes.toggleDrawer();
      }
    },
    setFavouriteHost(host) {
      // If clicking on already selected favourite, remove it directly without confirmation
      if (this.user_favourite && this.user_favourite.toUpperCase() === host) {
        this.confirmRemoveFavourite();
        return;
      }
      // Show confirmation dialog for setting favourite
      this.pendingFavouriteHost = host;
      this.favouriteConfirmDialog = true;
    },
    confirmSetFavourite() {
      const host = this.pendingFavouriteHost;
      const domain = localStorage.getItem("domain");
      let prefix = "cmp_" + domain;
      prefix = prefix == "cmp_admin" ? "public" : prefix;

      const user_id = localStorage.getItem("USER_ID");
      const user_dataset = {
        user_dataset: {
          favourite: host
        }
      };

      this.$api
        .put("/update_user_favourite/" + user_id + "/" + prefix, user_dataset)
        .then((response) => {
          this.user_favourite = host;
          this.favouriteConfirmDialog = false;
          this.pendingFavouriteHost = null;
          this.$toast.success(`${host} set as favourite. You will be redirected to ${host} after login.`);
        })
        .catch((err) => {
          console.error("Error updating favourite:", err);
          this.$toast.error('Failed to update favourite');
          this.favouriteConfirmDialog = false;
          this.pendingFavouriteHost = null;
        });
    },
    confirmRemoveFavourite() {
      const domain = localStorage.getItem("domain");
      let prefix = "cmp_" + domain;
      prefix = prefix == "cmp_admin" ? "public" : prefix;

      const user_id = localStorage.getItem("USER_ID");
      const user_dataset = {
        user_dataset: {
          favourite: null
        }
      };

      this.$api
        .put("/update_user_favourite/" + user_id + "/" + prefix, user_dataset)
        .then((response) => {
          this.user_favourite = null;
          this.$toast.success('Favourite removed');
        })
        .catch((err) => {
          console.error("Error removing favourite:", err);
          this.$toast.error('Failed to remove favourite');
        });
    },
    cancelFavouriteDialog() {
      this.favouriteConfirmDialog = false;
      this.pendingFavouriteHost = null;
    },
    toggleTheme() {
      // Toggle Vuetify's dark mode
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;

      // Save preference to localStorage
      localStorage.setItem('theme_mode', this.$vuetify.theme.dark ? 'dark' : 'light');
    },
    getDomainLogo() {
      this.logoUrl = localStorage.getItem("logoUrl") ? localStorage.getItem("logoUrl") : null;
    },
    handleLogoError() {
      console.error('Error loading logo image');
      this.logoUrl = null;
    },
    open__dialog() {
      if (this.is_board_page == true) {
        if (this.is__adani_page == true) {
          this.$emit('to_open_MenuDialog');
        } else if (this.is__gmr_page == true) {
          this.$emit('to_open_MenuDialog');
        } else if (this.is__vardhman_page == true) {
          this.$emit('to_open_MenuDialog');
        }
        else if (this.is__parle_page == true) {
          this.$emit('to_open_MenuDialog');
        } else if (this.is__granules_page == true) {
          this.$emit('to_open_MenuDialog');
        } else if (this.is__emami_page == true) {
          this.$emit('to_open_MenuDialog');
        } else {
          this.$emit('to_open_MenuDialog');
        }
      } else {
        this.$emit('to_open_MenuDialog');
      }
    },
    setFallbackImage(event) {
      event.target.src = require('@/assets/Menu/Empty_Profile_Pic.jpg');
    },
    UpdateProfile() {
      const routeData = this.$router.resolve({
        path: "/scorecard_board",
        query: {
          is_BoardStructure: 'true',
          boardUsersID: localStorage.getItem("USER_ID"),
        }
      })
      window.open(routeData.href, '_blank');
    },
    logout() {
      // Check if user has SCN_ANALYTICS permission
      let screen_right_dataset = JSON.parse(
        localStorage.getItem("SCREEN_RIGHT_DATASET")
      );

      let hasAnalyticsAccess = false;

      if (
        screen_right_dataset != null &&
        screen_right_dataset != "" &&
        screen_right_dataset != undefined &&
        screen_right_dataset.length != 0
      ) {
        // Filter screen rights for SCN_ANALYTICS
        var filteredScreen = screen_right_dataset.filter(function (item) {
          return item.screen_code === "SCN_ANALYTICS";
        });

        // Check if user has landing permission for SCN_ANALYTICS
        for (var i = 0; i < filteredScreen.length; i++) {
          if (filteredScreen[i].landing) {
            hasAnalyticsAccess = true;
            break;
          }
        }
      }

      // Only call analytics API if user has SCN_ANALYTICS permission
      if (hasAnalyticsAccess) {
        const token_update = {
          token: null,
          email: this.logged_user_Email,
          product_code: "PRMS",
          sub_domain: this.domain,
        };
        api
          .post("analytics_token_update", token_update)
          .then(() => {
            this.clearStorage();
          })
          .catch(() => {
            this.clearStorage();
          });
      } else {
        // No analytics access, clear storage directly
        this.clearStorage();
      }
    },
    async clearStorage() {
      await invalidateTokenOnLogout();
      localStorage.removeItem("ENTITY_ID");
      localStorage.removeItem("TOKEN");
      localStorage.clear();
      this.$router.push({ path: "/login" });
    },
    Switch_Entities() {
      this.$emit("Switch_Entities")
    },

    // NOTE (20260304150000): switch company for login_by_domain (starrboard.com) users
    // NOTE (20260926052418): ALL_ENTITIES is a snapshot from login, so
    // companies added later only showed after sign-out/sign-in. Open instantly
    // with the cached list, then refresh from the server and update both the
    // dialog and the cache. If the refresh fails, the cached list still works.
    async open_switch_company() {
      let cached = [];
      try {
        cached = JSON.parse(localStorage.getItem("ALL_ENTITIES") || "[]");
      } catch {
        cached = [];
      }
      this.company_switch_entities = cached;
      this.show_company_switch_dialog = true;
      this.company_switch_loading = !cached.length;

      try {
        const res = await this.$papi.get("sessions/my_entities");
        const fresh = (res && res.data && res.data.entities) || [];
        if (fresh.length) {
          const sorted = [...fresh].sort((a, b) =>
            (a.entity_name || "").localeCompare(b.entity_name || "")
          );
          localStorage.setItem("ALL_ENTITIES", JSON.stringify(sorted));
          this.company_switch_entities = sorted;
        }
      } catch (e) {
        console.warn("[switch company] refresh failed, using cached list:", e && e.message);
        if (!cached.length) {
          this.global_push_toast("error", "[ERR_AUTH_005] Unable to load company list");
          this.show_company_switch_dialog = false;
        }
      } finally {
        this.company_switch_loading = false;
      }
    },

    async handle_company_switch_confirm(entity) {
      this.company_switch_loading = true;
      try {
        // Prefer USER_EMAIL from localStorage; fall back to LOGIN_USERID
        // for accounts that log in via username (no email).
        const email = localStorage.getItem("USER_EMAIL") || localStorage.getItem("LOGIN_USERID");

        if (!email) {
          this.company_switch_loading = false;
          this.global_push_toast("error", "[ERR_AUTH_006] User email not found. Please sign in again.");
          return;
        }

        if (!entity || !entity.entity_id) {
          this.company_switch_loading = false;
          this.global_push_toast("error", "[ERR_AUTH_007] Invalid entity selected.");
          return;
        }

        let product_type = "STARR";
        if (localStorage.getItem("is_boardpage") === "true") product_type = "STARR_Board";
        else if (localStorage.getItem("is_family_book") === "true") product_type = "STARR_FamilyBook";

        await processDomainEntitySwitch(email, entity, this.$router, this, product_type);

        // Success: close the dialog. If processDomainEntitySwitch ended in an
        // SPA router.push (no full page reload), this component stays mounted,
        // so without this the "Loading your data…" overlay would be stuck
        // visible forever even though the switch already completed.
        this.company_switch_loading = false;
        this.show_company_switch_dialog = false;
      } catch (err) {
        this.company_switch_loading = false;
        this.global_push_toast("error", err.message || "[ERR_AUTH_004] Company switch failed");
      }
    },

    redirect_to_dashboard() {

      // Check if familybook is selected - redirect to FamilyDashboard
      if (this.is_family_book == true) {
        this.$router.push({
          path: "/familybook/FamilyDashboard",
        });
        return;
      }

      if (this.is_boardpage == true) {
        if (this.chairman_flag == true || this.ceo_flag == true) {
          this.$router.push({
            path: "/BoardDashBoard",
          });
        }
        else if (this.secretary_flag == true) {
          this.$router.push({
            path: "/SecretaryBoard",
          });
        } else {
          this.$router.push({
            path: "/scorecard_new",
          });
        }
      }
    },
    redirect_to_leader_ship_stucture() {
      this.$router.push('/Board_Designation');
    },
    redirect_to_family_tree() {
      this.$router.push('/familybook/family_tree');
    },
    redirect_to_family_office() {
      this.$router.push('/familybook/family_office');
    },
    redirect_to_family_forum() {
      this.$router.push('/familybook/Family_Forms');
    },
    open_chat() {
      this.chatDialog = true;
    },
    // Host switching methods
    async fetchUserFlags() {
      const userId = localStorage.getItem("USER_ID");
      if (!userId) return;

      try {
        const response = await api.get(`/get_company_data_and_host_dtls/${userId}`);
        const hostData = response.data.host_data || {};
        const companyData = response.data.company_data || [];

        this.user_starr_flag = hostData.starr_flag;
        this.user_board_flag = hostData.board_flag;
        this.user_family_book_flag = hostData.family_book_flag;
        this.user_favourite = hostData.favourite || null;

        // Handle company data
        if (companyData && companyData.length > 0) {
          const entityId = parseInt(localStorage.getItem("ENTITY_ID"));
          if (entityId) {
            // Filter companies for current entity
            this.company_dataset = companyData
              .filter(company => company.parent_id === entityId)
              .map(company => ({
                id: company.id,
                name: company.name,
                parent_id: company.parent_id
              }));

            this.has_company_data = this.company_dataset.length > 0;

            // Load company_id from localStorage if exists
            const storedCompanyId = localStorage.getItem("COMPANY_ID");
            if (storedCompanyId) {
              this.company_id = parseInt(storedCompanyId);
            } else if (this.has_company_data && this.company_dataset.length > 0) {
              // If no stored company, use the first company
              const firstCompany = this.company_dataset[0];
              this.company_id = firstCompany.id;
              localStorage.setItem("COMPANY_ID", firstCompany.id);
              localStorage.setItem("company_name", firstCompany.name);
            }
          }
        } else {
          this.company_dataset = [];
          this.has_company_data = false;
        }

        // After fetching flags, detect current host
        this.detectCurrentHost();
      } catch (error) {
        console.error('Error fetching user flags:', error);
        this.user_starr_flag = false;
        this.user_board_flag = false;
        this.user_family_book_flag = false;
        this.company_dataset = [];
        this.has_company_data = false;
      }
    },

    detectCurrentHost() {
      const hostname = window.location.hostname;
      const currentPath = this.$route ? this.$route.path : '';
      const storedHost = localStorage.getItem("SELECTED_HOST");

      // Check stored host first, then route, then hostname
      if (currentPath.includes('familybook') || storedHost === 'familybook') {
        this.currentHost = 'familybook';
        this.isfamily_book = true;
      } else if (hostname.includes('myboardpage') && storedHost !== 'familybook') {
        this.currentHost = 'board';
      } else if ((hostname.includes('compliance') || hostname.includes('tectalik')) && storedHost !== 'familybook') {
        this.currentHost = 'starr';
      }
    },

    isCurrentHost(host) {
      return this.currentHost === host;
    },

    selectCompany(company) {
      // Set the selected company
      this.company_id = company.id;
      // Save to localStorage
      localStorage.setItem("COMPANY_ID", company.id);
      localStorage.setItem("company_name", company.name);
      this.$toast.success(`Company changed to ${company.name}`);
    },

    async switchToHost(host) {
      // No user-level validation - host options are shown based on entity flags only

      // Save selection
      localStorage.setItem("SELECTED_HOST", host);
      localStorage.setItem("selected_host_flag", host);

      // Check if switching to same host
      if (this.isCurrentHost(host)) {
        this.$toast.info('Already on ' + this.getHostDisplayName(host));
        return;
      }

      // Open in new tab with environment-aware URLs
      const entityId = localStorage.getItem("ENTITY_ID");
      const domain = localStorage.getItem("domain");
      const node_env = (process.env.NODE_ENV || 'development').toLowerCase().trim();
      const hostname = window.location.hostname.toLowerCase();

      let baseUrl = '';

      // Generate URL based on environment and selected host
      if (host === 'board') {
        if (node_env === 'production') {
          baseUrl = `https://${domain}.myboardpage.com/`;
        } else if (node_env === 'development') {
          baseUrl = `https://${domain}.staging.myboardpage.com/`;
        } else {
          // local environment
          baseUrl = `http://${domain}.myboardpage:8080/`;
        }
      } else if (host === 'starr') {
        if (hostname.includes('starrboard')) {
          // STARRboard deployment — all tenants share the same domain, no subdomain routing.
          // Stay on the current origin so the #auth= hash is processed by the same app instance.
          baseUrl = `${window.location.origin}/`;
        } else if (node_env === 'production') {
          baseUrl = `https://${domain}.tectalik.com/`;
        } else if (node_env === 'development') {
          baseUrl = `https://${domain}.compliance-staging.tectalik.com/`;
        } else {
          // local environment
          baseUrl = `http://${domain}.compliance:8080/`;
        }
      } else if (host === 'familybook') {
        localStorage.setItem("is_family_book", "true");
        if (hostname.includes('starrboard')) {
          // STARRboard deployment — stay on current origin
          baseUrl = `${window.location.origin}/`;
        } else if (node_env === 'production') {
          if (hostname.includes('board') || hostname.includes('myboardpage')) {
            baseUrl = `https://${domain}.myboardpage.com/`;
          } else {
            baseUrl = `https://${domain}.tectalik.com/`;
          }
        } else if (node_env === 'development') {
          if (hostname.includes('board') || hostname.includes('myboardpage')) {
            baseUrl = `https://${domain}.staging.myboardpage.com/`;
          } else {
            baseUrl = `https://${domain}.compliance-staging.tectalik.com/`;
          }
        } else {
          // local environment
          if (hostname.includes('myboardpage')) {
            baseUrl = `http://${domain}.myboardpage:8080/`;
          } else {
            baseUrl = `http://${domain}.compliance:8080/`;
          }
        }
      }

      if (baseUrl) {
        // Prepare localStorage data to transfer
        const localStorageData = {
          TOKEN: localStorage.getItem("TOKEN"),
          USER_ID: localStorage.getItem("USER_ID"),
          USER_NAME: localStorage.getItem("USER_NAME"),
          USER_EMAIL: localStorage.getItem("USER_EMAIL"),
          ENTITY_ID: entityId,
          entity_name: localStorage.getItem("entity_name"),
          BRANCH_ID: localStorage.getItem("BRANCH_ID"),
          IS_ADMIN: localStorage.getItem("IS_ADMIN"),
          domain: domain,
          USER_DESIGNATION: localStorage.getItem("USER_DESIGNATION"),
          LOGGED_EMP_ID: localStorage.getItem("LOGGED_EMP_ID"),
          LOGGED_EMP_NO: localStorage.getItem("LOGGED_EMP_NO"),
          tectalik_product_list: localStorage.getItem("tectalik_product_list"),
          MODULE_RIGHTS_DATASET: localStorage.getItem("MODULE_RIGHTS_DATASET"),
          SCREEN_RIGHT_DATASET: localStorage.getItem("SCREEN_RIGHT_DATASET"),
          Self_Rating_Setting: localStorage.getItem("Self_Rating_Setting"),
          kpi_calc: localStorage.getItem("kpi_calc"),
          CUSTOMER_LIST: localStorage.getItem("CUSTOMER_LIST"),
          APPRAISAL_PERIOD_MSTR: localStorage.getItem("APPRAISAL_PERIOD_MSTR"),
          expiry_date: localStorage.getItem("expiry_date"),
          entitydata: localStorage.getItem("entitydata"),
          is_boardpage: host === 'board' ? 'true' : 'false',
          is_family_book: host === 'familybook' ? 'true' : 'false',
          logoUrl: localStorage.getItem("logoUrl"),
          resultat: localStorage.getItem("resultat"),
          SELECTED_HOST: host,
          // Include company data if available
          COMPANY_ID: localStorage.getItem("COMPANY_ID"),
          company_name: localStorage.getItem("company_name")
        };

        // Encode and open new tab
        const encodedData = btoa(encodeURIComponent(JSON.stringify(localStorageData)));
        let fullUrl = '';
        if (host === 'familybook') {
          // For familybook, add the /familybook/FamilyDashboard route
          // Use hash fragment (#) instead of query param (?) to avoid 414 URI Too Large error
          fullUrl = `${baseUrl}familybook/FamilyDashboard#auth=${encodedData}`;
        } else {
          fullUrl = `${baseUrl}#auth=${encodedData}`;
        }
        window.open(fullUrl, '_blank');

        this.$toast.success(`Switching to ${this.getHostDisplayName(host)}...`);
      }
    },

    getHostDisplayName(host) {
      const names = {
        'starr': 'Starr (Compliance)',
        'board': 'Board Page',
        'familybook': 'Familybook'
      };
      return names[host] || host;
    },
  },
}
</script>

<style>
/* Global styles to hide theme toggle when chat drawer is open */
/* The v-overlay is shown when v-navigation-drawer is open with temporary prop */
.v-overlay--active~.theme-toggle-wrapper,
.v-navigation-drawer--open~.theme-toggle-wrapper,
body.v-navigation-drawer--open .theme-toggle-wrapper {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

/* Force chat drawer z-index higher than toggle button and overlay */
.card-details-drawer.v-navigation-drawer {
  z-index: 10000 !important;
}

/* When chat overlay is active, hide the toggle */
.v-overlay.v-overlay--active+.dashboard-redesign .theme-toggle-wrapper,
.v-overlay--active .theme-toggle-wrapper,
.v-overlay--active+* .theme-toggle-wrapper,
body:has(.card-details-drawer.v-navigation-drawer--open) .theme-toggle-wrapper {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

/* Setup popover card (v-menu renders outside scoped DOM) */
.setup-popover-menu {
  border-radius: 10px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.14) !important;
  border: 1px solid #E6E4EE !important;
  overflow: visible !important;
}

.setup-popover-card {
  padding: 10px 12px !important;
  width: 200px !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.setup-popover-card .setup-pop-header {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 8px;
}

.setup-popover-card .setup-pop-title {
  font-size: 11px;
  font-weight: 800;
  color: #1E1E2F;
}

.setup-popover-card .setup-pop-sub {
  font-size: 9px;
  color: #9A96A8;
  margin-top: 1px;
}

.setup-popover-card .setup-pop-track {
  height: 4px;
  background: #EEEDF4;
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 8px;
}

.setup-popover-card .setup-pop-fill {
  height: 100%;
  background: linear-gradient(90deg, #6366F1, #10B981);
  border-radius: 2px;
  transition: width 0.6s ease;
}

.setup-popover-card .setup-pop-btn {
  display: block;
  width: 100%;
  background: linear-gradient(90deg, #6366F1 0%, #4F46E5 100%);
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 5px 0;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s;
  text-align: center;
}

.setup-popover-card .setup-pop-btn:hover {
  opacity: 0.88;
}

/* Profile dropdown icon fix — v-menu renders outside scoped DOM */
.sub_list_txt .v-icon {
  color: #3F4254 !important;
}
.v-list-item:hover .sub_list_txt .v-icon {
  color: #3F4254 !important;
}
</style>